export default __webpack_public_path__ + "images/60108cb129dc30d555b5ac01474542e4.png";